import React from 'react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle
} from '../../ui/alert-dialog';

export function DeleteExpenseDialog({ expense, onConfirm, onCancel }) {
  return (
    <AlertDialog open={!!expense} onOpenChange={(open) => !open && onCancel()}>
      <AlertDialogContent data-testid="delete-expense-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Delete this expense?</AlertDialogTitle>
          <AlertDialogDescription>
            "{expense?.description}" (${expense?.amount?.toFixed(2)}) will be removed from the event budget.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="cancel-delete-expense-btn">Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-red-600 hover:bg-red-700" data-testid="confirm-delete-expense-btn">
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
